import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { HttpClient } from '@angular/common/http';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IResponse } from '../../core/interfaces/response';
import { IReportChecklist } from '../interfaces/report-checklist';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({ providedIn: 'root' })
export class ReportChecklistService {
  constructor(private cacheService: CacheService, private http: HttpClient, private urlBuilder: UrlBuilderService) {}

  /**
   * Function to get the report checklist data from endpoint
   *
   * @param filterData filter values from filter component
   */
  public getCheckListReport(filterData: IOutputFilter): Observable<IReportChecklist[]> {
    const companyId = this.cacheService.local('session').user.company.id;
    const url = `${this.urlBuilder.apiUrl}/Report/GetChecklistReport?startDate=${filterData.startDate}&endDate=${filterData.endDate}&shiftId=${filterData.shiftId}&machineTypeList=${filterData.machineTypeId}&machineList=${filterData.machineId}&companyId=${companyId}`;
    return this.http.get<IResponse>(url).pipe(
      map((res) => {
        if (res.error.errorNumber === 0) {
          // no errors
          return res.data;
        }
        throw throwError(res.error);
      }),
      catchError((err) => this.handleError(err)),
    );
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    console.log(err);
    return throwError(err);
  }

  /**
   * Get excel from GetChecklistReportDetailDocument endpoint
   */
  public GetChecklistReportDetailExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetChecklistReportDetailDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
